import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGeneralRequest = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 56 56",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M49 25.375V6.125H1.75v31.5H14v8.663l9.45-8.663h11.463"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "m29.925 42.613 18.2-18.113 6.125 6.125-18.2 18.112m-6.125-6.125-3.85 9.888 9.975-3.763m-6.125-6.125 6.125 6.125"
	})]
});
export default SvgIconGeneralRequest;
